import { FaUserAlt, FaTools, FaCog } from "react-icons/fa";
// import { HiDocumentText } from "react-icons/hi2";
import { IoDocumentText } from "react-icons/io5";
import { TiFlowMerge } from "react-icons/ti";
import { ISidebarMenuModel } from "../../../models/create-sidebar-menu.model";

export const AgentFormSidebarMenu: ISidebarMenuModel[] = [
  {
    label: "",
    menus: [
      {
        menu: "Agents Profile",
        tab: "profile",
        icon: <FaUserAlt />,
      },
    ],
  },
  {
    label: "Agent Instructions",
    menus: [
      {
        menu: "Core Instructions",
        tab: "core",
        icon: <IoDocumentText />,
      },
      {
        menu: "Tools",
        tab: "tools",
        icon: <FaTools />,
      },
      {
        menu: "Flow Builder",
        tab: "builder",
        icon: <TiFlowMerge />,
      },
    ],
  },
  // {
  //   label: "Connected resources",
  //   menus: [

  //     {
  //       menu: "Integration",
  //       tab: "integration",
  //       icon: <HiDocumentText />,
  //     },
  //   ],
  // },
  {
    label: "More options",
    menus: [
      {
        menu: "Advanced Settings",
        tab: "settings",
        icon: <FaCog />,
      },
    ],
  },
];
